<h5 mat-dialog-title appLocalizationPopupDirective localizationCode="BuySellPlanPublishHistory">{{ 'BuySellPlanPublishHistory' | translate: {Default: "Buy Sell Plan Publish History"} }}</h5>

<mat-dialog-content>
    <app-data-grid-comp
        [gridId]="gridId"
        [columns]="columns"
        [filterCategories]="filterCategories"
        [gridDataResult]="gridDataResult"
        [pageSize]="pageSize"
        [skip]="skip"
        [rowSelectionSettings]="{
            canSelectRows: false
        }"
        clickableRows="false"
        maxHeight="40"
        [isLoading]="isLoading"
        hideActionButtons="true"
        searchable="false"
        showRefreshButton="true"
        (emitRefreshEvent)="getBuySellPlanPublishHistory()"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        [sort]="sort"
        (emitGridStateChangeEvent)="gridStateChange($event)"
    ></app-data-grid-comp>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
</mat-dialog-actions>